import { useState } from 'react';
import { useTranslation } from '../i18n';
import CardNB from './ui-nb/CardNB';

const FAQ_KEYS = ['q1', 'q2', 'q3', 'q4', 'q5'] as const;

export default function FaqSection() {
  const { t } = useTranslation();
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <CardNB>
      <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '1rem', color: '#000' }}>
        {t('faq.title', 'Frequently Asked Questions')}
      </h2>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {FAQ_KEYS.map((key, index) => {
          const question = t(`faq.${key}.question`, '');
          const answer = t(`faq.${key}.answer`, '');
          const isExpanded = expandedIndex === index;

          return (
            <div key={key} style={{ border: '2px solid #000' }}>
              <button
                type="button"
                onClick={() => toggle(index)}
                style={{
                  width: '100%',
                  padding: '0.75rem 1rem',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  background: isExpanded ? '#000' : 'var(--nb-bg-card)',
                  color: isExpanded ? '#fff' : '#000',
                  border: 'none',
                  cursor: 'pointer',
                  textAlign: 'left',
                  fontWeight: 500,
                  fontSize: '0.875rem',
                }}
              >
                <span>{question}</span>
                <span style={{ fontSize: '1.25rem', fontWeight: 700 }}>
                  {isExpanded ? '−' : '+'}
                </span>
              </button>

              {isExpanded && (
                <div
                  style={{
                    padding: '0.75rem 1rem',
                    background: 'var(--nb-bg-page)',
                    color: 'var(--nb-text-muted)',
                    fontSize: '0.875rem',
                    lineHeight: 1.6,
                  }}
                >
                  {answer}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </CardNB>
  );
}
